(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silvergrain-blog-post"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slugify(str) {
      return str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function initBlogPost(root) {
      var content = root.querySelector('[data-blog-content]');
      var toc = root.querySelector('[data-blog-toc]');
      var list = root.querySelector('[data-blog-toc-list]');
      var body = root.querySelector('.silvergrain-blog-post__body');
      if (!content || !toc || !list || !body) return;

      var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
      if (headings.length < 2) return;

      var usedIds = {};
      var items = headings.map(function (h, idx) {
        var id = h.id || slugify(h.textContent || 'section-' + (idx + 1));
        var candidate = id;
        var n = 2;
        while (usedIds[candidate]) {
          candidate = id + '-' + n++;
        }
        id = candidate;
        usedIds[id] = true;
        h.id = id;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById(id);
          if (!target) return;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + id);
        });
        li.appendChild(a);
        list.appendChild(li);
        return { id: id, el: h, link: a };
      });

      toc.removeAttribute('hidden');
      body.classList.add('silvergrain-blog-post__body--with-toc');

      if ('IntersectionObserver' in window) {
        var links = {};
        items.forEach(function (i) { links[i.id] = i.link; });
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                Object.keys(links).forEach(function (k) { links[k].classList.remove('is-active'); });
                if (links[entry.target.id]) links[entry.target.id].classList.add('is-active');
              }
            });
          },
          { rootMargin: '-90px 0px -70% 0px', threshold: 0 }
        );
        items.forEach(function (i) { observer.observe(i.el); });
      }
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-blog-post]');
      for (var i = 0; i < roots.length; i++) initBlogPost(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silvergrain-contact-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindContactFaq = (scope = document) => {
      scope.querySelectorAll('[data-contact-faq-root]').forEach((root) => {
        if (root.dataset.bound === 'true') return;

        root.dataset.bound = 'true';
        root.classList.add('is-enhanced');
        const items = [...root.querySelectorAll('.silvergrain-contact-faq__item')];
        const navLinks = root.parentElement?.querySelectorAll('.silvergrain-contact-faq__nav-link') || [];

        const getGroupItems = (group) => {
          const normalizedGroup = group.trim();

          return items.filter((item) => (item.dataset.navGroup || '').trim() === normalizedGroup);
        };

        const syncActive = (group) => {
          navLinks.forEach((link) => {
            link.classList.toggle('is-active', (link.dataset.navGroup || '').trim() === group);
          });
        };

        const scrollActiveNav = (group) => {
          const activeLink = [...navLinks].find((link) => (link.dataset.navGroup || '').trim() === group);
          if (!(activeLink instanceof HTMLElement)) return;

          activeLink.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest',
          });
        };

        const setExpandedHeight = (item) => {
          const wrap = item.querySelector('.silvergrain-contact-faq__answer-wrap');
          if (!(wrap instanceof HTMLElement)) return;

          wrap.style.maxHeight = item.classList.contains('is-active') ? `${wrap.scrollHeight}px` : '0px';
        };

        const syncExpandedState = (item) => {
          const summary = item.querySelector('.silvergrain-contact-faq__summary');
          if (!(summary instanceof HTMLElement)) return;
          summary.setAttribute('aria-expanded', item.classList.contains('is-active') ? 'true' : 'false');
        };

        const showGroup = (group, { scrollIntoView = false } = {}) => {
          const groupItems = getGroupItems(group);
          if (!groupItems.length) return;

          items.forEach((item) => {
            const shouldShow = groupItems.includes(item);
            item.hidden = !shouldShow;

            if (!shouldShow) {
              item.classList.remove('is-active');
              item.classList.remove('is-closing');
              syncExpandedState(item);
              setExpandedHeight(item);
            }
          });

          let activeItem =
            groupItems.find((item) => item.classList.contains('is-active')) ||
            groupItems.find((item) => item.dataset.openByDefault === 'true') ||
            groupItems[0];

          if (!activeItem) return;

          groupItems.forEach((item) => {
            item.classList.toggle('is-active', item === activeItem);
            item.classList.remove('is-closing');
            syncExpandedState(item);
            setExpandedHeight(item);
          });

          syncActive(group);
          scrollActiveNav(group);

          if (scrollIntoView) {
            activeItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        };

        items.forEach((item) => {
          const summary = item.querySelector('.silvergrain-contact-faq__summary');
          const wrap = item.querySelector('.silvergrain-contact-faq__answer-wrap');

          if (!(summary instanceof HTMLElement) || !(wrap instanceof HTMLElement)) return;

          if (item.dataset.initialOpen === 'true') {
            item.classList.add('is-active');
          }

          syncExpandedState(item);
          setExpandedHeight(item);

          let animationFrame = 0;

          const cancelAnimation = () => {
            if (animationFrame) {
              cancelAnimationFrame(animationFrame);
              animationFrame = 0;
            }
          };

          const expandItem = () => {
            cancelAnimation();
            item.classList.remove('is-closing');
            wrap.style.maxHeight = '0px';
            item.classList.add('is-active');
            syncExpandedState(item);

            animationFrame = requestAnimationFrame(() => {
              wrap.style.maxHeight = `${wrap.scrollHeight}px`;
            });
          };

          const collapseItem = () => {
            cancelAnimation();
            item.classList.add('is-closing');
            wrap.style.maxHeight = `${wrap.scrollHeight}px`;

            animationFrame = requestAnimationFrame(() => {
              item.classList.remove('is-active');
              syncExpandedState(item);
              wrap.style.maxHeight = '0px';
            });
          };

          wrap.addEventListener('transitionend', (event) => {
            if (event.propertyName !== 'max-height') return;

            if (!item.classList.contains('is-active')) {
              item.classList.remove('is-closing');
            } else {
              wrap.style.maxHeight = `${wrap.scrollHeight}px`;
            }
          });

          summary.addEventListener('click', (event) => {
            event.preventDefault();

            const group = (item.dataset.navGroup || '').trim();
            const groupItems = getGroupItems(group);

            if (item.classList.contains('is-active')) {
              collapseItem();
              return;
            }

            groupItems.forEach((other) => {
              if (other === item) return;
              other.classList.remove('is-closing');
              other.classList.remove('is-active');
              syncExpandedState(other);
              setExpandedHeight(other);
            });

            expandItem();
            syncActive(group);
          });
        });

        navLinks.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            const group = (link.dataset.navGroup || '').trim();
            if (!group) return;
            showGroup(group, { scrollIntoView: false });
          });
        });

        const initialGroup =
          [...navLinks].find((link) => link.classList.contains('is-active'))?.dataset.navGroup?.trim() ||
          items.find((item) => item.dataset.openByDefault === 'true')?.dataset.navGroup?.trim() ||
          items[0]?.dataset.navGroup?.trim();

        if (initialGroup) showGroup(initialGroup);

        const syncAllHeights = () => {
          items.forEach((item) => {
            if (!item.hidden) setExpandedHeight(item);
          });
        };

        window.addEventListener('resize', syncAllHeights, { passive: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindContactFaq(), { once: true });
    } else {
      bindContactFaq();
    }

    document.addEventListener('shopify:section:load', (event) => {
      bindContactFaq(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silvergrain-featured-photographer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeaturedPhotographer(root) {
      var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-fp-lightbox]'));
      if (!triggers.length) return;

      var overlay = root.querySelector('[data-fp-lightbox-overlay]');
      var imgEl = overlay.querySelector('[data-fp-lightbox-img]');
      var counterEl = overlay.querySelector('[data-fp-counter]');
      var prevBtn = overlay.querySelector('[data-fp-prev]');
      var nextBtn = overlay.querySelector('[data-fp-next]');
      var closeBtn = overlay.querySelector('[data-fp-close]');

      var sources = triggers.map(function (el) {
        var i = el.querySelector('img');
        return {
          src: (i && (i.currentSrc || i.src)) || '',
          alt: (i && i.alt) || ''
        };
      });

      var currentIndex = 0;

      function showAt(i) {
        currentIndex = (i + sources.length) % sources.length;
        var src = sources[currentIndex];
        imgEl.classList.remove('is-loaded');
        imgEl.src = src.src;
        imgEl.alt = src.alt;
        counterEl.textContent = (currentIndex + 1) + ' / ' + sources.length;
        imgEl.onload = function () { imgEl.classList.add('is-loaded'); };
      }

      function open(i) {
        showAt(i);
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }

      function close() {
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      triggers.forEach(function (el, i) {
        el.addEventListener('click', function () { open(i); });
      });

      prevBtn.addEventListener('click', function (e) { e.stopPropagation(); showAt(currentIndex - 1); });
      nextBtn.addEventListener('click', function (e) { e.stopPropagation(); showAt(currentIndex + 1); });
      closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });

      document.addEventListener('keydown', function (e) {
        if (!overlay.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') showAt(currentIndex - 1);
        if (e.key === 'ArrowRight') showAt(currentIndex + 1);
      });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-featured-photographer]');
      for (var i = 0; i < roots.length; i++) initFeaturedPhotographer(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
